import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'POST',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `/am/@@user.rpc`,
    services: {
        products: {
            cacheable: true,
            cacheLifetime: 24,
            parameters: []
        }
    }
});
export default svc;
